export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10860.c2d39ef4.jpg";